<template>
  <div id="app">
    <div class="navbar">
      <div class="navbar-box">
        <div class="logo">
          <img src="../static/logo.png" alt="">
        </div>
        <ul class="navmun">
          <li class="nav_li" v-for="item in nav" :key="item.id" :class="{'active' : i===item.id}" style="cursor: pointer;" @click="toPath(item.path,item.id)" @mouseenter="enter(item.id)" @mouseleave="leave()">{{item.name}}
            <ul v-if="item.subItems" class="subnebu">
              <li class="subItems_list" v-for="(itema,indexa) in item.subItems" :key="indexa" @click="subnebuBtn(indexa,itema,item.name,itema.text)">{{itema.text}}
                <ul class="navChild" v-if="itema.child">
                  <li class="navChild_list" v-for="(itemaa,indexaa) in itema.child" :key="indexaa" @click.stop="toPathChild(itemaa.path)">{{itemaa.name}}</li>
                </ul>
              </li>
            </ul>
          </li>
          <li class="nav_li">
            <span @click="changeLanguageen()" :class="{'Languageenactives' : LanguagezhShow===1}" style="cursor: pointer;">中</span>
            <span>|</span>
            <span @click="changeLanguagezh()" :class="{'Languageenactives' : LanguagezhShow===0}" style="cursor: pointer;">EN</span>
          </li>
        </ul>
      </div>
    </div>
    <div style="height:80px;width:100%;"></div>
    <router-view />
    <div class="footbar">
      <div class="footbar_message">
        <el-row>
          <el-col :span="2">
            <div class="grid-content bg-purple" style="margin-top:40px">
              <div class="li_img"><img src="../static/logo.png" alt=""></div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="grid-content bg-purple" style="margin-top:40px">
              <p>{{$t("address.Beijing")}}</p>
              <p>{{$t("address.Shenzhen")}}</p>
              <p>{{$t("address.Taiwan")}}</p>
              <p>{{$t("address.Changsha")}}</p>
              <!-- <p>京ICP备16059616号-1</p> -->
            </div>
          </el-col>
          <el-col :offset='1' :span="7">
            <div class="grid-content bg-purple-light" style="margin-top:40px">
              <p>{{$t("address.tel")}}</p>
              <p style="height:30px;"></p>
              <p>{{$t("address.Business")}}</p>
              <p>{{$t("address.JoinUs")}}</p>
              <!-- <p>京公网安备 11010502040189号</p> -->

            </div>
          </el-col>
          <el-col :span="2">
            <div class="grid-content bg-purple-light" style="margin-top:40px">
              <div class="li_img2"><img src="../static/erweima.jpg" alt=""></div>
            </div>
          </el-col>
        </el-row>
        <div class="footbar_filing">{{$t("address.enterpriseName")}}｜<a href="http://www.beian.miit.gov.cn">京ICP备16059616号-1</a> ｜<img style="width:18px;margin-right: 4px;vertical-align: top;display: inline-block;" src="../static/filing.png" alt=""><a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502040189">京公网安备 11010502040189号</a></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
      linkClick: "",
      i: 0,
      inx:0,//导航选中的下标
      LanguagezhShow: 1 //1是中文，0是英文
    };
  },
  watch: {
    $route: "myroute"
  },
  computed: {
    nav() {
      return {
        Home: {
          id: 0,
          name: this.$t("home.nav.Home"),
          path: "Home",
          subItems: []
        },
        Technology: {
          id: 1,
          name: this.$t("home.nav.Technologies"),
          path: "Technology",
          subItems: [
            { text: "ADAS", click: true },
            { text: "DMS" },
            { text: this.$t("home.childrenNav.FaceRecognition") }
          ]
        },
        Product: {
          id: 2,
          name: this.$t("home.nav.Products"),
          path: "Product",
          subItems: [
            {
              text: this.$t("home.childrenNav.ProductequiPment"),
              click: true,
              child: [
                {
                  name: this.$t("home.grandchildrenNav.KYLFD"),
                  path: "KYLFD" //KY-LFD商用车主动安全设备
                },
                {
                  name: this.$t("home.grandchildrenNav.Polaris"),
                  path: "polarisTripREC" //Polaris北极星智能行车记录仪
                },
                {
                  name: this.$t("home.grandchildrenNav.KYJLY"),
                  path: "KYJLY" //KY-JLY主动安全智能记录仪
                },
                {
                  name: this.$t("home.grandchildrenNav.KYHSj"),
                  path: "KYHSJ" //KY-HS]主动安全智能后视镜
                },
                {
                  name: this.$t("home.grandchildrenNav.HDDashcam"),
                  path: "HDashcam" //高清行车记录仪
                },
                {
                  name: this.$t("home.grandchildrenNav.Intelligent"),
                  path: "intelligent" //智能车载核心板
                }
              ]
            },
            {
              text: this.$t("home.childrenNav.PreinstalledSolution"),
              child: [
                {
                  name: this.$t("home.grandchildrenNav.installedADAS"),
                  path: "installedADAS" //前装ADAS产品
                },
                {
                  name: this.$t("home.grandchildrenNav.installedDMS"),
                  path: "installedDMS" //前装DMS产品
                }
              ]
            },
            {
              text: this.$t("home.childrenNav.sdk"),
              child: [
                {
                  name: this.$t("home.grandchildrenNav.Genera"),
                  path: "generalSDK" //标准版ADAS SDK
                },
                {
                  name: this.$t("home.grandchildrenNav.Dashcam"),
                  path: "Dashcam" //行车记录仪专用ADAS SDK
                },
                {
                  name: this.$t("home.grandchildrenNav.Professional"),
                  path: "professSdk" //升级版SDK
                }
              ]
            },
            {
              text: this.$t("home.childrenNav.CloudPlatform"),
              child: [
                {
                  name: this.$t("home.grandchildrenNav.YKYVehicles"),
                  path: "YKYVehicles" //易开云车辆管理平台
                }
              ]
            }
          ]
        },
        About: {
          id: 3,
          name: this.$t("home.nav.AboutUs"),
          path: "About",
          subItems: [
            { text: this.$t("home.childrenNav.About"), click: true },
            { text: this.$t("home.childrenNav.Joinus") }
          ]
        },
        Journalism: {
          id: 4,
          name: this.$t("home.nav.Newsroom"),
          path: "Journalism",
          subItems: []
        }
      };
    }
  },
  methods: {
    //点击三级导航跳转到相应的路由
    toPathChild(path) {
      this.i = 2;
      this.inx=2;//导航选中的下标
      //滚动条回到顶部
      $("html,body").animate({ scrollTop: 0 }, 0);
      //跳转路由
      this.$router.push({
        name: path
      });
    },
    //点击英文
    changeLanguagezh() {
        let {enUrlHost} = window.cfg;
        if(enUrlHost){
            window.open(enUrlHost);
            return;
        }
        this.$i18n.locale = "en-us";
        this.LanguagezhShow = 0;
        this.$store.commit("CHANGE_LAN", 0);
    },
    //点击中文
    changeLanguageen() {
      this.$i18n.locale = "zh-cn";
      this.LanguagezhShow = 1;
      this.$store.commit("CHANGE_LAN", 1);
    },
    toPath(path, index) {
       this.inx=index;//导航选中的下标
      //跳转路由
      if (path != "Product") {
        this.i = index;
        this.$router.push({
          name: path
        });
      }
    },
    //鼠标移入事件
    enter(index) {
      this.i = index;
    },
    //鼠标移出事件
    leave() {
      console.log(this.inx);
      this.i = this.inx;
    },
    myroute() {
      //切换时滚动条滚动到顶部
      window.scrollTo(0, 0);
    },
    subnebuBtn(i, nav, itemN, navtext) {
      if (itemN == "产品" || itemN == "Products") {
      } else if (itemN == "技术" || itemN == "Technologies") {
        if (this.$route.path != "/Technology") {
          //先跳转到技术页路由
          this.$router.push({
            name: "Technology"
          });
          //延迟执行
          setTimeout(() => {
            if (i == 0) {
              var city_topa = $($(".Technology_wrap")[0]).offset().top - 80;
              $("html,body").animate({ scrollTop: city_topa }, 500);
            } else if (i == 1) {
              var city_topa = $($(".Technology_wrapb")[0]).offset().top - 80;
              $("html,body").animate({ scrollTop: city_topa }, 500);
            } else if (i == 2) {
              var city_topa = $($(".Technology_wrap")[1]).offset().top - 80;
              $("html,body").animate({ scrollTop: city_topa }, 500);
            }
          }, 200);
        } else {
          if (i == 0) {
            var city_topa = $($(".Technology_wrap")[0]).offset().top - 80;
            $("html,body").animate({ scrollTop: city_topa }, 500);
          } else if (i == 1) {
            var city_topa = $($(".Technology_wrapb")[0]).offset().top - 80;
            $("html,body").animate({ scrollTop: city_topa }, 500);
          } else if (i == 2) {
            var city_topa = $($(".Technology_wrap")[1]).offset().top - 80;
            $("html,body").animate({ scrollTop: city_topa }, 500);
          }
        }
      } else if (itemN == "关于我们" || itemN == "About Us") {
        if (this.$route.path != "/About") {
          //先跳转到技术页路由
          // this.$router.push({
          //   name: "About"
          // });
          this.$router.push({
            name: "indexa"
          });
          //延迟执行
          setTimeout(() => {
            if (i == 0) {
              var city_topa = $($(".About_wrapa")[0]).offset().top - 80;
              $("html,body").animate({ scrollTop: city_topa }, 500);
            } else if (i == 1) {
              var city_topa = $($(".About_wrapb")[0]).offset().top - 80;
              $("html,body").animate({ scrollTop: city_topa }, 500);
            }
          }, 200);
        } else {
          if (i == 0) {
            var city_topa = $($(".About_wrapa")[0]).offset().top - 80;
            $("html,body").animate({ scrollTop: city_topa }, 500);
          } else if (i == 1) {
            var city_topa = $($(".About_wrapb")[0]).offset().top - 80;
            $("html,body").animate({ scrollTop: city_topa }, 500);
          }
        }
      }
    }
  },
  created() {
    // console.log(this.$route.path);
    this.i = 2;
    switch (this.$route.path) {
      case "/":
        this.i = 0;
        break;
      case "/Home":
        this.i = 0;
        break;
      case "/Technology":
        this.i = 1;
        break;
      case "/Product":
        this.i = 2;
        break;
      case "/About":
        this.i = 3;
        break;
      case "/Journalism":
        this.i = 4;
        break;
    }
    this.inx=this.i
  },
  mounted() {}
};
</script>

<style>
.el-carousel__arrow {
  background-color: #000;
  opacity: 0.5;
  color: #fff;
}
.el-carousel__arrow:hover {
  background-color: #000;
  opacity: 0.7;
  color: #fff;
}
.el-carousel__indicators--outside {
  margin-top: 20px;
}
ul {
  padding: 0px;
}
li {
  list-style: none;
}

.navbar {
  width: 100%;
  height: 80px;
  line-height: 80px;
  background: #000;
  position: fixed;
  z-index: 9999;
  top: 0px;
  right: 0px;
  font-family: PingFangSC-Regular;
}

.navbar-box {
  min-width: 1100px;
  margin: 0 auto;
}

.navmun {
  list-style-type: none;
  text-align: right;
  margin-right: 100px;
}

.nav_li {
  display: inline-block;
  /* width: 87px; */
  height: 80px;
  text-align: center;
  padding: 0 30px;
  font-size: 14px;
  color: #fff;
  position: relative;
}
.nav_li span {
  margin-left: 4px;
  display: inline-block;
  height: 54px;
}
.Languageenactives {
  border-bottom: 2px solid red;
}
.logo {
  float: left;
  width: 60px;
  height: 53px;
  margin-top: 10px;
  margin-left: 100px;
}

.logo img {
  width: 100%;
  height: 100%;
}

.active {
  border-bottom: 3px solid red;
  /* position: relative; */
}

.subnebu {
  min-width: 178px;
  background: #000;
  color: #fff;
  position: absolute;
  top: 80px;
  left: 0px;
}
.subItems_list {
  text-align: left;
  line-height: 16px;
  padding-left: 12px;
  font-size: 14px;
  letter-spacing: 1px;
  margin-top: 20px;
  display: none;
}
.nav_li:hover .subItems_list {
  display: block;
}
/* .subItems_list:first-child {
  margin-top: px;
} */

.subItems_list:last-child {
  margin-bottom: 25px;
}
.subItems_list:hover {
  color: red;
}
.navChild {
  background: #000;
  position: absolute;
  top: 0;
  left: 178px;
  width: 388px;
  min-height: 240px;
  display: none;
  padding-left: 10px;
  color: #fff;
  font-size: 12px;
  border-left: 1px solid red;
}
.navChild_list {
  margin-top: 20px;
  line-height: 16px;
}
.navChild_list:last-child {
  margin-bottom: 25px;
}
.subItems_list:hover .navChild {
  display: block;
}
.navChild_list:hover {
  color: red;
}
.actives {
  display: block;
}
.activeChild {
  display: block;
}
.footbar {
  width: 100%;
  min-height: 200px;
  background: #000;
}

.footbar_message {
  width: 90%;
  margin: 0 auto;
  color: #fff;
  font-size: 12px;
}

.footbar_message p {
  line-height: 30px;
}
.footbar_filing {
  border-top: 1px solid #434344;
  text-align: center;
  margin-top: 20px;
  height: 50px;
  padding-top: 20px;
}
.footbar_filing a {
  color: #fff;
}
.li_img {
  width: 60px;
  height: 53px;
}

.li_img2 {
  width: 90px;
  height: 90px;
  float: right;
}

.li_img img,
.li_img2 img {
  width: 100%;
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue